import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '../hooks/auth';

const ProtectedRoute = ({ redirectPath = '/', children }: any) => {
  const { user } = useAuth();

  const [userState, setUserState] = useState<any>();

  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setUserState(user);
      setReady(true);
    }, 2000);

    return () => clearTimeout(timeout);
  }, [user]);

  if (!userState?.id && ready) {
    return <Navigate to={redirectPath} replace />;
  }

  return children || <Outlet />;
};

export { ProtectedRoute };
